const sitemap_entity_type = {
  SITEMAP_ROUTES_CITY: "sitemap-routes-city",
  SITEMAP_ROUTES_COUNTRY: "sitemap-routes-country",
  SITEMAP_ROUTES_INDEX: "sitemap-routes-index",
  SITEMAP_STOPS_CITY: "sitemap-stops-city",
  SITEMAP_STOPS_COUNTRY: "sitemap-stops-country",
  SITEMAP_STOPS_INDEX: "sitemap-stops-index",
  SITEMAP_POI_INDEX: "sitemap-points-of-interest-index",
  SITEMAP_POI_COUNTRY: "sitemap-points-of-interest-country",
  SITEMAP_POI_CITY: "sitemap-points-of-interest-city",
  SITEMAP_CITIES_COUNTRY: "sitemap-cities-country",
  SITEMAP_CITIES_INDEX: "sitemap-cities-index",
  SITEMAP_TRAINS_TO_COUNTRY: "sitemap-trains-to-country",
  SITEMAP_TRAINS_TO_INDEX: "sitemap-trains-to-index",
  SITEMAP_PARTNERS_INDEX: "sitemap-partners-index"
} as const;

export const non_sitemap_landing_pages_entity_type = {
  ROUTE: "route",
  POINT_OF_INTEREST_ROUTE: "point-of-interest-route",
  MULTIMODAL_ROUTE: "multimodal-route",
  POINT_OF_INTEREST: "point-of-interest",
  TRAIN_ROUTE: "train-route",
  PARTNER: "partner",
  // profile and partner are the same page. On SEO VE, we use profile because it would be the "correct" name
  PROFILE: "profile",
  COUNTRY: "country",
  // TODO change from stop to station
  STOP: "stop",
  STATION: "station",
  CITY: "city",
  TRAINS_TO_PAGE: "trains-to",
  HOME: "home",
  SEM_ROUTE_PAGE: "sem-route-page",
  SEM_CITY_PAGE: "sem-city-page"
} as const;

// Entity types for landing pages that represent journeys between two points (origin + destination)
export const journey_landing_pages_entity_type = {
  ROUTE: "route",
  POINT_OF_INTEREST_ROUTE: "point-of-interest-route",
  MULTIMODAL_ROUTE: "multimodal-route",
  TRAIN_ROUTE: "train-route",
  SEM_ROUTE_PAGE: "sem-route-page"
} as const satisfies Partial<typeof non_sitemap_landing_pages_entity_type>;

type NonSitemapLandingPagesEntityTypeKeys =
  keyof typeof non_sitemap_landing_pages_entity_type;
export type NonSitemapLandingPagesEntityType =
  (typeof non_sitemap_landing_pages_entity_type)[NonSitemapLandingPagesEntityTypeKeys];

export const landing_pages_entities_type = {
  ...non_sitemap_landing_pages_entity_type,
  ...sitemap_entity_type
} as const;

export const landing_pages_entities_trains_types = [
  "train-route",
  "trains-to"
] as const satisfies Array<NonSitemapLandingPagesEntityType>;

export const landing_pages_entities_journey_types = Object.values(
  journey_landing_pages_entity_type
);
